module.exports = __webpack_public_path__ + "img/Gold.d1304e06.png";